import {ChangeEventHandler} from 'react'
import {Input, Props as InputProps} from './Input'

type Props = InputProps & {
  min?: number
  max?: number
  value?: number
  onChange: ChangeEventHandler<HTMLInputElement>
}

export const NumberInput = ({max, min, onChange, value, ...props}: Props) => {
  return (
    <Input
      {...props}
      type="number"
      pattern="[0-9.]+"
      min={min}
      max={max}
      value={value}
      onChange={onChange}
    />
  )
}
